<div class="wre-table-container w-100">
    <div #tableContainer class="table-responsive" (scroll)="offset = tableContainer.scrollLeft + 'px'">
        <table class="table wre-table fixed-column table-hover p-0 m-0">
            <thead class="text-center p-0 m-0" [style.left]="'-' + offset">
                <tr class="t-header">
                    <th class="text-nowrap col-ellipsis column-active"></th>
                    <th class="text-nowrap col-ellipsis column-active" *ngIf="fieldType === 'Reviewer'"></th>
                    <th class="text-nowrap col-ellipsis column-users"  > {{fieldType == 'Reviewer' ? 'Name' : 'Field Value'}}</th>
                    <th class="text-nowrap col-ellipsis column-adgroups">Status</th>
                </tr>
            </thead>

            <tbody class="p-0 m-0">
                <tr class="tr-padding" *ngFor="let item of list;last as isLast" [ngClass]="{'border-bottom': isLast}">
                    <td class="text-nowrap col-ellipsis column-active" *ngIf="item.isAdded || item.isDeleted ||item.isUpdated">
                        <i class="far" [ngClass]=" {'fa-plus': item.isAdded,'fa-exchange' : item.isUpdated ,'fa-minus': item.isDeleted}"></i>
                    </td>
                    <td class="text-nowrap col-ellipsis column-active" *ngIf="fieldType === 'Reviewer'">
                      <i class="far" ngClass="fa-user"></i>
                    </td>
                    <td class="text-nowrap col-ellipsis column-users">
                        <span *ngIf="item.value">{{ item.value }}</span>
                    </td>
                    <td class="text-nowrap col-ellipsis column-adgroups">
                     <span *ngIf="item.status">Active</span>
                     <span *ngIf="!item.status">Inactive</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

